// @ts-check

// Vendor imports
const React = require('react')

/**
 * @param {string} [description]
 * @returns {Symbol}
 */
function useSymbol(description) {
  /** @type {React.MutableRefObject<Symbol>} */
  const ref = React.useRef()
  if (!ref.current) {
    ref.current = Symbol(description)
  }
  return ref.current
}

module.exports = useSymbol
